import React from 'react'
import { Typography } from '@material-ui/core';

export default function Copyright() {
    return (
        <Typography style={{marginBottom: 16}} variant="body2" color="textSecondary" align="center">
            {'Copyright © Obhai'}
            {/* <Link color="inherit" href="#">
                Obhai
            </Link> */}
            {' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}